<template>
  <div
    class="d-flex confirmation-container justify-content-center align-items-center"
  >
    <b-card class="confirmation-box">
      <div class="box-title mb-4">Confirm Sign Up</div>

      <div class="mb-4">
        We've sent you a 6-digit confirmation code to complete your sign-up. Please check your email and enter the code below to confirm your sign-up.
      </div>

      <div
        v-if="isShowConfirmError"
        class="alert alert-danger alert-outline alert-dismissible fade show"
        role="alert"
      >
        <i
          class="uil uil-exclamation-octagon font-size-16 text-danger me-2"
        ></i>
        {{ confirmErrorMessage }}
        <button
          type="button"
          class="btn-close"
          @click="closeConfirmError"
        ></button>
      </div>

      <b-form-group class="mb-2">
        <label>Confirmation Code <span class="red">*</span></label>
        <b-form-input
          placeholder="Enter 6-Digit Confirmation Code"
          v-model="code"
          trim
        ></b-form-input>
      </b-form-group>
      <div class="mb-4">
        Didn't receive your code?
        <span class="text-primary" v-if="countDown != 0">Resend code in {{countDown}} seconds.</span>
        <a  v-if="countDown == 0" class="text-primary cursor-pointer" @click="resend">Resend Code</a>
      </div>

      <b-button
        class="w-100 mb-3"
        variant="primary"
        :disabled="isConfirmationLoading"
        @click="confirmRegistration"
      >
        <span
          v-if="isConfirmationLoading"
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Confirm
      </b-button>
      <chat-support />
    </b-card>
  </div>
</template>

<script>
import { authMethods } from "@/state/helpers";
import chatSupport from '../../../components/chat-support.vue';

export default {
  components: { chatSupport },
  props: ["username"],
  data() {
    return {
      countDown: 60,
      code: null,
      isConfirmationLoading: false,
      confirmErrorMessage: null,
      isShowConfirmError: false,
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    ...authMethods,
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    closeConfirmError() {
      this.isShowConfirmError = false;
    },
    confirmRegistration() {
      this.isConfirmationLoading = true;
      this.isShowConfirmError = false;
      this.confirmErrorMessage = null;

      this.confirm({
        username: this.username,
        code: this.code,
      })
        .then((res) => {
          this.isConfirmationLoading = false;
          if (res == "SUCCESS") {
            this.$emit("success");
          }
        })
        .catch((err) => {
          this.isConfirmationLoading = false;
          this.confirmErrorMessage = err.message;
          this.isShowConfirmError = true;
        });
    },
    resend() {
      this.countDown = 60;
      this.countDownTimer();
      this.isConfirmationLoading = true;
      this.resendCode(this.username).then(
        () => (this.isConfirmationLoading = false)
      );
    },
  },
  mounted(){
    this.countDownTimer();
  }
};
</script>

<style>
</style>